import { CSSProperties, useContext, useState } from "react";
import { Drawer, List, ListItem } from "@material-ui/core";
import { Link, useHistory, useLocation } from "react-router-dom";
import { NavigationItem } from "./Navbar";
import SubscriptionStatusIndicator from "./Components/SubscriptionStatusIndicator";
import useBrand, { BrandExistsState } from 'Hooks/useBrand';
import { UpgradeModalContext } from "Hooks/UpgradeModalContext";
import Colors from "modules/Colors";
import useUser from "Hooks/useUser";
import { makeKey } from "modules/Utils";
import Icon from "elements/Icon";
import Sty from "modules/Sty";
import { isSymphonyAdmin } from "helpers/admin";
import useMaestroChat from "Hooks/useMaestroChat";
import MobileHeader from "components/MobileHeader";
import ButtonSymphony from "elements/ButtonSymphony";
import useWebsiteBuilder, { getWebsiteBuilderPath } from "Hooks/useWebsiteBuilder";
import useCampaignBuilder from "Hooks/useCampaignBuilder";

const GRAY_MENU_COLOR = "#888888";
const NAVIGATION_FONT_SIZE = 11;

const getCurrentlySelectedPage = (
    location: {
        pathname: string;
    },
    navigationItems: NavigationItem[]
): NavigationItem | undefined => {
    const pathname = location.pathname;
    // first search the main HREFs, then the alternate HREFs to see if it matches
    const selectedPage = navigationItems.find((navItem: NavigationItem) => {
        const {
            href: navItemHref,
            alternateHrefs,
            // name
        } = navItem;

        if (navItemHref === pathname) {
            return true
        }

        if (alternateHrefs && alternateHrefs.indexOf(pathname) > -1) {
            return true
        }

        return false
    });

    return selectedPage;
}

interface MobileNavigationProps {
    navigationItems: NavigationItem[];
}

const MobileNavigation = ({
    navigationItems
}: MobileNavigationProps) => {
    const history = useHistory()
    const location = useLocation();
    const { isProBrand, currentBrand } = useBrand()
    const { proFreeTrialRedeemed, isSymphonyAdmin } = useUser()
    const {
        setShowCreateNewCampaignModal
    } = useCampaignBuilder();
    const { handleOpenModal } = useContext(UpgradeModalContext);

    const {
        isChatOpen,
        setIsChatOpen
    } = useMaestroChat()

    const websiteBuilderPath = getWebsiteBuilderPath(currentBrand?.slug || '')

    let freeTrialOver = !proFreeTrialRedeemed()
    // location used to check if item selected
    const currentNavigationItem = getCurrentlySelectedPage(location, navigationItems);

    // to handle opening / closing mobile drawer
    const [drawerOpen, setOpenDrawer] = useState<boolean>(false)

    const [value, setValue] = useState(0);

    // Filter navigation items for the BottomNavigation bar
    const bottomNavigationItems = navigationItems.filter((navItem: NavigationItem) => navItem.showOnMobileMainMenu);

    // Filter navigation items for the Drawer
    const drawerNavigationItems = navigationItems.filter((navItem: NavigationItem) => !navItem.showOnMobileMainMenu);

    const showUpgradeToProButton = () => {
        if (false) {
            return (
                <div
                    className="bottomNavigationContainer3"
                    style={{
                        backgroundColor: Colors.purpleDark,
                        height: 56,
                        paddingLeft: 12,
                        paddingRight: 12,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderBottom: `1px solid ${Colors.greyDark}`,
                    }}
                >
                    <ButtonSymphony
                        className="bottomNavigationButton"
                        onClick={() => setIsChatOpen(true)}
                        variant="primary"
                        size="small"
                    >
                        Open Maestro Chat
                    </ButtonSymphony>
                </div>
            )
        }

        if (isProBrand) {
            return null
        }

        // only show upgrade to Pro on Dashboard
        if (currentNavigationItem?.name === "Dashboard") {
            return (
                <>
                    <div
                        className="bottomNavigationContainer2"
                        style={{
                            backgroundColor: Colors.purpleDark,
                            display: 'flex',
                            alignItems: 'center',
                            paddingBottom: 8,
                            paddingTop: 8,
                            paddingLeft: 12,
                            paddingRight: 12,
                            justifyContent: 'center',
                            borderBottom: `1px solid ${Colors.greyDark}`,
                        }}
                    >
                        <SubscriptionStatusIndicator
                            maxWidth="100%"
                            width="100%"
                            margin="auto"

                            text={freeTrialOver ? "Upgrade to Pro" : "Start 14-day Free Trial"}
                            showStars
                            handleOpenModal={() => handleOpenModal({
                                source: "Mobile Dashboard - Bottom Bar"
                            })}
                        />
                    </div>
                </>
            )
        }
    }

    const renderBottomNavigatorContainer1 = () => {
        const isDashboard = location.pathname === '/' || location.pathname.includes('/dashboard')
        if (!isDashboard) {
            return null
        }

        return (
            <div
                className="bottomNavigationContainer1"
                style={sty.bottomNavigationContainer1}
            >
                <ButtonSymphony
                    className="bottomNavigationButtonNewWebsite"
                    size="small"
                    onClick={() => history.push(websiteBuilderPath)}
                    iconLeft="plus"
                    width="100%"
                    iconLeftOffset={-8}
                    color="white"
                    iconLeftSize={18}
                >
                    New Website
                </ButtonSymphony>
                <ButtonSymphony
                    className="bottomNavigationButtonNewCampaign"
                    size="small"
                    onClick={() => {
                        setShowCreateNewCampaignModal(true)
                    }}
                    iconLeft="plus"
                    width="100%"
                    iconLeftOffset={-8}
                    iconLeftSize={18}
                >
                    New Campaign
                </ButtonSymphony>
            </div>
        )
    }

    return (
        <div className="mobileNavigationComponent">
            <div
                className="mobileNavigationInner"
                style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 99
                }}
            >
                {showUpgradeToProButton()}

                {renderBottomNavigatorContainer1()}

                <div
                    className="mobileNavigationBottomNavigation"
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: Colors.purpleDark,
                        height: 56,
                        paddingLeft: 12,
                        paddingRight: 12
                    }}
                >
                    {bottomNavigationItems.map((item: NavigationItem, index: number) => {
                        const isSelected = currentNavigationItem && currentNavigationItem.name === item.name;

                        // const IconComponent = item.iconComponent;
                        const color = isSelected ? 'white' : GRAY_MENU_COLOR;

                        return (
                            <div
                                key={makeKey(item.name, index)}
                                className="iconContainer1"
                                style={sty.iconContainer}
                                onClick={() => {
                                    setOpenDrawer(false)
                                    history.push(item.href!)
                                }}
                            >
                                <Icon
                                    className="mobileNavigationBottomNavigationActionIcon"
                                    icon={item.icon || ''}
                                    color={color}
                                />
                                <div
                                    className="mobileNavigationBottomNavigationActionText"
                                    style={{
                                        color: color,
                                        fontSize: NAVIGATION_FONT_SIZE,
                                    }}
                                >
                                    {item.name}
                                </div>
                                <div style={isSelected ? sty.iconDividerSelected : sty.iconDividerBlank} />
                            </div>
                        );
                    })}
                    <div
                        className="iconContainer2"
                        onClick={() => setOpenDrawer(true)}
                        style={sty.iconContainer}
                    >
                        <Icon
                            className="mobileNavigationBottomNavigationActionIcon"
                            icon="gear"
                            color={GRAY_MENU_COLOR}
                        />
                        <div style={{ color: GRAY_MENU_COLOR, fontSize: NAVIGATION_FONT_SIZE }}>
                            Settings
                        </div>
                        <div style={sty.iconDividerBlank} />
                    </div>
                </div>
            </div>

            <Drawer
                className="mobileNavigationDrawer"
                anchor="bottom"
                open={drawerOpen}
                onClose={() => setOpenDrawer(false)}
            >
                <MobileHeader
                    className="dashboardComponentMobileHeader"
                    onClickBrand={() => {
                        setOpenDrawer(false)
                    }}
                />
                <List>
                    {drawerNavigationItems.map((navItem: NavigationItem, index: number) => {
                        const isSelected = currentNavigationItem && currentNavigationItem.name === navItem.name;

                        const additionalProps: any = {}

                        if (navItem.onClick) {
                            additionalProps['onClick'] = (e: any) => {
                                setOpenDrawer(false);
                                if (navItem.onClick) {
                                    navItem!.onClick(e)
                                }
                            }
                        } else {
                            additionalProps['component'] = Link
                            additionalProps['to'] = navItem.href!
                            additionalProps['onClick'] = () => { setOpenDrawer(false) }
                        }

                        return (
                            <ListItem
                                key={makeKey(navItem.name, index)}
                                className="mobileNavigationListItem"
                                button
                                {...additionalProps}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 12,
                                    padding: 16,
                                }}
                            >
                                <Icon
                                    className="mobileNavigationListItemIcon"
                                    icon={navItem.icon || ""} // NOTE: most likely dont need empty string
                                    color={isSelected ? Colors.purpleLight : GRAY_MENU_COLOR}
                                />
                                <div
                                    className="listItemTextElement"
                                    style={{ color: isSelected ? Colors.purpleLight : GRAY_MENU_COLOR }}
                                >
                                    {navItem.name}
                                </div>
                            </ListItem>
                        );
                    })}
                </List>
            </Drawer>
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    iconContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: 53,
        flexShrink: 0,
        gap: 1
    },
    iconDividerSelected: {
        marginTop: 1,
        width: 24,
        height: 1.5,
        backgroundColor: Colors.purpleLight,
        borderRadius: 100,
        transition: 'all 0.2s ease'
    },
    iconDividerBlank: {
        marginTop: 1,
        width: 24,
        height: 1.5,
        backgroundColor: Colors.purpleDark,
        borderRadius: 100
    },
    bottomNavigationContainer1: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        backgroundColor: Colors.purpleDark,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 24,
        paddingBottom: 24,
        height: 40,
        borderBottom: `1px solid ${Colors.greyDark}`,
    }
}

export default MobileNavigation
